<template>
    <vue-pdf-app file-name="polizaGenerada" :pdf=urlPdf></vue-pdf-app>
</template>

<script>

import pdfService from "@/services/pdfs.service.js";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";
import swal from 'sweetalert';
//const { VUE_APP_NOTE_URL } = process.env;


export default {
    name: "Home",
    props: ["userData"],
    components: {
        VuePdfApp
    },
    data: () => ({
        userData: {
            id: null,
        },
        urlPdf: '',
        resPdf: null,

    }),
    async mounted() {
        try {
            var query = this.$route.query;
            var resPdfAws = await pdfService.pdfAwsBucket(query.id);
            if (resPdfAws.status == "ok") {
                this.urlPdf = resPdfAws.fileFinal;
            } else {
                throw new Error("No se encontró el registro en Aws");
            }
        } catch (error) {
            console.error(error);
            swal({ title: "No se encuentra el registro", icon: "error" });
        }
    },
};

</script>